/**
 * Structured error envelope.
 *
 * Per CLAUDE.md hard rule #6: every error returned to a caller is structured
 * with `{ code, message, retryable, details? }`. The envelope wraps these
 * under an `error` key so success vs. failure responses can be distinguished
 * by shape alone.
 */
import { z } from "zod";
/**
 * Canonical error codes. This list intentionally stays small — every new code
 * is a public-API addition that frontend and downstream consumers must handle.
 *
 * Extend with care; prefer reusing an existing code over inventing a new one.
 */
export const ERROR_CODES = [
    "invalid_input",
    "unauthorized",
    "authentication_failed",
    "authorization_denied",
    "not_found",
    "conflict",
    "rate_limited",
    "backend_unavailable",
    "timeout",
    "budget_exceeded",
    "quota_exceeded",
    "internal_error",
];
export const ErrorCodeSchema = z.enum(ERROR_CODES);
/**
 * Inner error payload — also used as a sub-shape inside `RunStatus.error` etc.
 */
export const ErrorPayloadSchema = z.object({
    code: ErrorCodeSchema,
    message: z.string(),
    retryable: z.boolean().optional(),
    details: z.record(z.unknown()).optional(),
});
/**
 * The full envelope wire format: `{ error: { code, message, retryable?, details? } }`.
 *
 * All non-2xx HTTP responses from the Portal API MUST conform to this shape.
 */
export const ErrorEnvelopeSchema = z.object({
    error: ErrorPayloadSchema,
});
//# sourceMappingURL=errors.js.map